import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
// import cookbook from '../assets/cookbook.png';
// import personalrecipe from '../assets/personalrecipe.png';
// import tastepref from '../assets/tastepref.png';

const MockupContainer = styled(motion.div)`
  position: relative;
  width: 300px;
  height: 625px;
  margin: 0 auto;
  z-index: 1;
`;

const PhoneFrame = styled(motion.div)`
  position: relative;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 45px;
  background: #0A0A0A;
  box-shadow: 0 25px 60px -12px rgba(0, 0, 0, 0.5),
              0 10px 20px -5px rgba(0, 0, 0, 0.4),
              inset 0 0 0 1px rgba(100, 100, 100, 0.2),
              -4px 0 5px -3px rgba(0, 0, 0, 0.7),
              4px 0 5px -3px rgba(0, 0, 0, 0.7);
  overflow: hidden;
  border: 10px solid #222;
  display: flex;
  flex-direction: column;
  transform: scale(0.95) !important; 
`;

const PhoneScreen = styled.div`
  width: 100%;
  height: 100%;
  background: #0F0F0F;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  border-radius: 35px;
`;

const VideoContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
`;

const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  margin: 0;
  padding: 0;
`;

const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 5;
  display: ${props => props.isPlaying ? 'none' : 'block'};
`;

const SideButton = styled.div`
  position: absolute;
  background: #0A0A0A;
  border-radius: 2px;
  z-index: 11;
  
  &.power {
    width: 4px;
    height: 60px;
    right: -4px;
    top: 140px;
    border-left: 1px solid #777;
  }
  
  &.volume-up {
    width: 4px;
    height: 40px;
    left: -4px;
    top: 130px;
    border-right: 1px solid #777;
  }
  
  &.volume-down {
    width: 4px;
    height: 40px;
    left: -4px;
    top: 185px;
    border-right: 1px solid #777;
  }
  
  &.silent-switch {
    width: 5px;
    height: 18px;
    left: -4px;
    top: 80px;
    border-right: 1px solid #777;
    border-radius: 2px;
  }
`;

const BottomBar = styled.div`
  position: absolute;
  bottom: 12px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 15px;
  height: 50px;
  z-index: 9;
`;

const BottomIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  
  &::before {
    content: '';
    width: 20px;
    height: 20px;
    background-color: rgba(255, 255, 255, 0.8);
    mask-image: ${props => props.icon};
    mask-size: contain;
    mask-position: center;
    mask-repeat: no-repeat;
  }
  
  &.home {
    width: 50px;
    height: 5px;
    border-radius: 3px;
    background: rgba(255, 255, 255, 0.8);
  }
`;

const DynamicIsland = styled.div`
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 34px;
  background: #000000;
  border-radius: 20px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.05);
  
  &::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    background: #333;
    border-radius: 50%;
    right: 15px;
  }
  
  &::before {
    content: '';
    position: absolute;
    width: 30px;
    height: 4px;
    background: #333;
    border-radius: 2px;
    left: 15px;
  }
`;

const StatusBar = styled.div`
  position: absolute;
  top: 12px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 25px;
  align-items: center;
  z-index: 9;
  font-size: 14px;
  font-weight: 600;
  color: white;
`;

const TimeDisplay = styled.div`
  text-align: left;
`;

const StatusIcons = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

const BatteryIcon = styled.div`
  width: 25px;
  height: 12px;
  border: 1.5px solid white;
  border-radius: 3px;
  padding: 1px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 18px;
    background-color: white;
    margin: 1px;
  }
  
  &::after {
    content: '';
    position: absolute;
    right: -4px;
    top: 3px;
    width: 2px;
    height: 4px;
    border-radius: 0 2px 2px 0;
    background-color: white;
  }
`;

const SignalIcon = styled.div`
  display: flex;
  align-items: flex-end;
  height: 12px;
  gap: 1px;
  
  span {
    width: 3px;
    background-color: white;
    border-radius: 1px 1px 0 0;
    
    &:nth-child(1) { height: 5px; }
    &:nth-child(2) { height: 7px; }
    &:nth-child(3) { height: 9px; }
    &:nth-child(4) { height: 11px; }
  }
`;

const CTAPhoneMockup = ({ videoSrc, isPlaying }) => {
  const videoRef = useRef(null);
  
  useEffect(() => {
    if (isPlaying && videoRef.current) {
      videoRef.current.play().catch(e => console.error('Ошибка воспроизведения видео:', e));
    }
  }, [isPlaying]);

  return (
    <MockupContainer
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
    >
      <PhoneFrame
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        <SideButton className="power" />
        <SideButton className="volume-up" />
        <SideButton className="volume-down" />
        <SideButton className="silent-switch" />
        
        <PhoneScreen>
          <VideoContainer>
            <VideoElement 
              ref={videoRef}
              src={videoSrc} 
              loop 
              muted 
              playsInline
            />
            <VideoOverlay isPlaying={isPlaying} />
          </VideoContainer>
        </PhoneScreen>
      </PhoneFrame>
    </MockupContainer>
  );
};

export default CTAPhoneMockup; 